import Component from "@ember/component"
import { action, get, set } from "@ember/object"
import { inject as service } from "@ember/service"

export default class AdminSidebarFiscalGroup extends Component {
  @service("ember-store")
  store

  @service
  modalManager

  canShowActionMenu = false

  @action
  changeGroupState() {
    set(this, "canShowActionMenu", false)
    get(this, "modalManager").openModal("admin/fiscal-group/change-group-state", {
      fiscalGroup: get(this, "model"),
    })
  }
}
